var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
export const CheckBox = (props) => {
    const [value, setValue] = useState(props.checked || false);
    const [loading, setLoading] = useState(false);
    const { onSubmit } = props;
    useEffect(() => {
        setValue(props.checked || false);
    }, [props.checked]);
    const submit = (checked) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            yield onSubmit(checked);
        }
        finally {
            setLoading(false);
        }
    });
    return (_jsxs("div", { children: [loading && _jsx(CircularProgress, { sx: { mr: '2px', color: '#007ca3', verticalAlign: 'middle' }, size: 18, color: "inherit" }), !loading && _jsx(Checkbox, { onChange: e => submit(e.target.checked), checked: value, color: "primary", inputProps: { 'aria-label': 'secondary checkbox' } })] }));
};
